<script setup lang="ts">
import { t } from '@/utils/i18n';
</script>

<template>
  <div
    :title="t('Freqtrade logo')"
    class="mx-auto dark:bg-white bg-black transition-all duration-300 mask-[url(@/assets/freqtrade-logo-mask.png)] mask-no-repeat mask-contain mask-center"
  />
</template>
